import React, { useState } from "react";
import CardLayout from "../../common/cardLayout/CardLayout";
import RiskPill from "../../common/RiskPill";
import { ChatAvatar } from "./ChatAvatar";
import { ReactComponent as SearchIcon } from "../../../assets/icons/Search.svg";
import { ReactComponent as CloseIcon } from "../../../assets/icons/CloseIcon.svg";
import Modal from "react-modal";
import { getInitials } from "../../../util/helpers";
import { NoAssessments } from "../patient/InfoTabs/FlaggedJournals";

const ChatTile = ({ name, risk, onClick, closeChat, avatar = null }) => {
  let url = `https://placehold.co/70x70/f1f1f5/395E9D/?text=${getInitials(
    name
  )}`;

  if (avatar) {
    url = avatar;
  }
  return (
    <div
      className="chat-tile d-flex justify-content-start"
      style={{ cursor: "pointer" }}
      onClick={() => {
        onClick();
        closeChat();
      }}
    >
      <ChatAvatar name={name} url={url} padding="10px 10px" />
      <div className="container-fluid" style={{ width: "100%" }}>
        <div
          className="d-flex"
          style={{ gap: "10px", display: "block", marginTop: "5%" }}
        >
          <label style={{ cursor: "pointer" }}>{name}</label>
          <RiskPill
            type={risk}
            icon_height="10px"
            icon_width="10px"
            icon_styles={{ marginTop: "3px" }}
            styles={{ fontSize: "0.75rem", cursor: "pointer" }}
          />
        </div>
      </div>
    </div>
  );
};
const ChatListing = ({ chatPatients, setChatData, closeChat }) => {
  const [filterText, setFilterText] = useState("");
  return (
    <div className="container-fluid mb-2" style={{ padding: "0px" }}>
      <div className="d-flex search-icon-container my-3">
        <SearchIcon style={{ marginTop: "2%" }} />
        <input
          placeholder="Find a chat"
          onInput={(e) => {
            setFilterText(e.target.value);
          }}
          value={filterText}
        />
      </div>
      <div className="mb-3 chat-list" style={{ height: "65vh" }}>
        {chatPatients?.length === 0 && (
          <NoAssessments
            show_link={false}
            text="Looks like you have no patients yet!"
          />
        )}
        {chatPatients
          .filter((chat) => {
            if (chat?.name?.toLowerCase().includes(filterText)) {
              return chat;
            }
            return null;
          })
          .map((chat, index) => {
            return (
              <ChatTile
                key={index}
                name={chat?.name}
                count={chat?.count}
                date={chat?.modified}
                onClick={() => {
                  setChatData(chat, chat?.patient_id);
                }}
                previewText={chat?.latest_message}
                risk={chat?.flag}
                avatar={chat?.profile_picture}
                closeChat={closeChat}
              />
            );
          })}
      </div>
    </div>
  );
};

const StartChat = (props) => {
  Modal.setAppElement("#root");
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      height: "80%",
      borderRadius: "16px",
      transform: "translate(-50%, -50%)",
      width: "30%",
    },
  };

  const closeModal = () => {
    props.setIsOpen(false);
  };

  return (
    <Modal
      isOpen={props.modalIsOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel=""
    >
      <div className="container-fluid">
        <button
          style={{
            position: "absolute",
            right: "15px",
            border: "0px",
            backgroundColor: "transparent",
          }}
          onClick={closeModal}
        >
          <CloseIcon />
        </button>
        <CardLayout style={{ padding: "2px" }}>
          <div className="container-fluid">
            <ChatListing
              chatPatients={props.patientData}
              setChatData={props.setChatData}
              closeChat={closeModal}
            />
          </div>
        </CardLayout>
      </div>
    </Modal>
  );
};

export default StartChat;
